import React from 'react';

import Button from '@material-ui/core/Button';
import BobConfirmButton from './../../../components/BobConfirmButton';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';

import classes from '../CreateEntityModal.module.css';

const DeleteConfigurationModal = ({
    onClose,
    onConfirm,
    selectedConfiguration,
    bulkDelete=false
}) => {
    
    const handleDelete = async () => {
        onConfirm();
        onClose();  
    };

    const handleClose = () => {
        onClose();
    };

    if (bulkDelete) {
        return (
            <React.Fragment>
                <ErrorOutlineIcon className={classes.warningIcon} />
                <div className={classes.text}>
                    <p className={classes.desc}> Are you sure you want to delete the selected configurations?</p>
                </div>
                <Button
                    className={classes.Button}
                    onClick={handleClose}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    label={'Yes'}
                    onClick={handleDelete}
                />
            </React.Fragment>
        );
    }
    else {
        return (
            <React.Fragment>
                <ErrorOutlineIcon className={classes.warningIcon} />
                <div className={classes.text}>
                    <p className={classes.desc}> Are you sure you want to delete the configuration below?</p>
                    <p className={classes.name}>View Name</p>
                    <p className={classes.entityName}>{selectedConfiguration.name}</p>
                </div>
                <Button
                    className={classes.Button}
                    onClick={handleClose}
                    variant="contained"
                >
                    Cancel
                </Button>
                <BobConfirmButton
                    className={classes.ButtonWithMargin}
                    label={'Yes'}
                    onClick={handleDelete}
                />
            </React.Fragment>
        );
    }
};

export default DeleteConfigurationModal;
